import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { API, getLocalProductUrl } from "../../Constants/APIs";
import PasscodeVerfiy from "../PasscodeVerify";
import ModelDynamicRecommend from "./ModelDynamicRecommend";
import { useParams } from "react-router-dom";
import MapScanAuthModal from "../MapScanAuthModal";
import {
  authenticateMapScanUser,
  clearMapScanToken,
  getCurrentMapScanUser,
  getMapScanToken,
  getMarkerById,
  getMarkerByModalProductId,
  saveMapScanModal,
  setMapScanToken,
} from "../../Helpers/mapScan";

const isLocationMapViewer = () =>
  window.location.pathname.startsWith("/location-map/modelDynamicviewer/");

export default function ModalDynamicFunctionalTemp() {
  const [isProtected, setisProtected] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isCheckingAuth, setIsCheckingAuth] = useState(isLocationMapViewer());
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(!isLocationMapViewer());
  const [errorMessage, setErrorMessage] = useState("");
  const id = useParams();

  useEffect(() => {
    const getProduct = () => {
      const productUrl = isLocationMapViewer()
        ? getLocalProductUrl(id.id)
        : API.getUrls.getSingleProduct + id.id;

      axios
        .get(productUrl)
        .then(({ data }) => {
          //    console.log("singleProduct ", data);
          setisProtected(!!data.product.is_protected);
          setIsLoading(false);
        })
        .catch((err) => {
          //    console.log("err ", err);
          setIsLoading(false);
        });
    };
    getProduct();
  }, []);

  useEffect(() => {
    if (!isLocationMapViewer()) {
      return;
    }

    const token = getMapScanToken();

    if (!token) {
      setIsCheckingAuth(false);
      return;
    }

    getCurrentMapScanUser(token)
      .then((data) => {
        if (data.status === "success") {
          setIsAuthenticated(true);
        } else {
          clearMapScanToken();
        }
      })
      .catch(() => {
        clearMapScanToken();
      })
      .finally(() => {
        setIsCheckingAuth(false);
      });
  }, []);

  useEffect(() => {
    if (!isLocationMapViewer() || !isAuthenticated) {
      return;
    }

    const token = getMapScanToken();
    const searchParams = new URLSearchParams(window.location.search);
    const markerIdFromQuery = searchParams.get("marker");
    const marker =
      getMarkerById(markerIdFromQuery) || getMarkerByModalProductId(id.id);

    if (!token) {
      return;
    }

    saveMapScanModal({
      modelId: id.id,
      scannedTime: new Date().toISOString(),
      token,
      markerId: marker?.id || "",
      markerTitle: marker?.title || "",
      markerLat: marker?.position?.lat ?? null,
      markerLng: marker?.position?.lng ?? null,
    }).catch(() => {});
  }, [id.id, isAuthenticated]);

  const [isVerify, setIsVerify] = useState(false);

  const handleAuthSubmit = async (payload) => {
    setIsAuthenticating(true);
    setErrorMessage("");

    try {
      const data = await authenticateMapScanUser(payload);

      if (data.status !== "success") {
        setErrorMessage(data.message || "Unable to continue.");
        return;
      }

      setMapScanToken(data.user.accessToken);
      setIsAuthenticated(true);
    } catch (error) {
      setErrorMessage("Unable to continue right now.");
    } finally {
      setIsAuthenticating(false);
      setIsCheckingAuth(false);
    }
  };

  if (isCheckingAuth) {
    return <div style={styles.loading}>Loading...</div>;
  }

  if (isLocationMapViewer() && !isAuthenticated) {
    return (
      <MapScanAuthModal
        errorMessage={errorMessage}
        isLoading={isAuthenticating}
        onSubmit={handleAuthSubmit}
        subtitle="Enter your details to open the scanned model."
        title="Let's begin."
      />
    );
  }

  return (
    <div>
      {isLoading ? (
        <></>
      ) : false && isProtected && !isVerify ? (
        <PasscodeVerfiy
          productId={id.id}
          onSubmit={() => {
            setIsVerify(true);
          }}
        />
      ) : (
        <ModelDynamicRecommend />
          )}
    </div>
  );
}

const styles = {
  loading: {
    alignItems: "center",
    color: "#0f172a",
    display: "flex",
    fontSize: "18px",
    justifyContent: "center",
    minHeight: "100vh",
  },
};
